import * as providersMatchers from './videosProviders';

type ProviderModule = { mediaMatch: { matcher: RegExp; url: string } };

function getVideoMatcherFromUrl(url: string, matcherToReturn?: keyof typeof providersMatchers) {
  if (matcherToReturn && (providersMatchers as any)[matcherToReturn]) {
    return (providersMatchers as any)[matcherToReturn] as ProviderModule;
  }
  const values = Object.values(providersMatchers) as ProviderModule[];
  return values.find((currentMatcher) => url.match(currentMatcher.mediaMatch.matcher));
}

export default function getIframeUrl(url = '', platformToMatch?: keyof typeof providersMatchers) {
  const videoMatcher = getVideoMatcherFromUrl(url, platformToMatch);
  if (!videoMatcher) return '';

  const { mediaMatch } = videoMatcher;
  const match = url.match(mediaMatch.matcher);
  if (!match) return '';

  let iframeUrl = mediaMatch.url;
  match.forEach((value, index) => {
    iframeUrl = iframeUrl.replace(`$${index}`, value || '');
  });

  return iframeUrl;
}
